import { createContext } from "react";

const SelectedTagsContext = createContext();

export default SelectedTagsContext;
